import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { WorkloadsMiscApiService } from '../api/workloads-misc-api.service';
import { ImagePerDay, HostDailySeries } from './models/image-per-day';
import { ServerChanges } from './models/server-change';
import { ImagePerDayApi } from '../api/models/image-per-day-api';
import { ServerChangesApi } from '../api/models/server-change-api';

@Injectable({
    providedIn: 'root'
})
export class WorkloadsMiscDomainService {
    constructor(private workloadsMiscApiService: WorkloadsMiscApiService) {
    }

    getImagesPerDay(days: number): Observable<HostDailySeries[]> {
        return this.workloadsMiscApiService.getImagesPerDay(days)
            .pipe(
                map((items: ImagePerDayApi[]) => {
                    const map = new Map<string, HostDailySeries>();

                    items.map(ImagePerDay.mapperFromApi).forEach((item: ImagePerDay) => {
                        if (!map.has(item.host)) {
                            map.set(item.host, { host: item.host, dates: [], counts: [] });
                        }
                        const series = map.get(item.host);

                        series.dates.push(item.date);
                        series.counts.push(item.count);
                    });

                    return Array.from(map.values());
                })
            );
    }

    getServerChanges(days: number): Observable<ServerChanges> {
        return this.workloadsMiscApiService.getServerChanges(days)
            .pipe(
                map((api: ServerChangesApi) => ServerChanges.mapperFromApi(api))
            );
    }
}
